import { render, staticRenderFns } from "./RecommendationFeedbackPopUp.vue?vue&type=template&id=4a0d7d53&scoped=true"
import script from "./RecommendationFeedbackPopUp.vue?vue&type=script&lang=ts"
export * from "./RecommendationFeedbackPopUp.vue?vue&type=script&lang=ts"
import style0 from "./RecommendationFeedbackPopUp.vue?vue&type=style&index=0&id=4a0d7d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d7d53",
  null
  
)

export default component.exports